import { Component, inject, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-frontchannel-logout',
  template: ''
})
export class FrontChannelLogoutComponent implements OnInit {

  private readonly msalService = inject(MsalService, { optional: true });

  ngOnInit(): void {

    // Limpia cache local MSAL
    this.msalService?.instance.clearCache();

    // // opcional
    // sessionStorage.clear();
    // localStorage.clear();

    // cerrar iframe silenciosamente
    window.close();
  }
}